var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"22","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.90723 3.81494H7.88086V5.09668H4.90723V8.46582H3.54492V5.09668H0.571289V3.81494H3.54492V0.702148H4.90723V3.81494Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }